import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/** Recibe el redirect del backend tras Google OAuth.
 *  Casos:
 *  - ?token=... → guarda token y entra al dashboard
 *  - ?linked=ok → muestra éxito, refresca usuario
 *  - ?error=... → muestra error
 */
export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    const linked = params.get("linked");
    const error = params.get("error");

    const run = async () => {
      if (error) {
        toast.error(decodeURIComponent(error));
        navigate("/login");
        return;
      }
      if (token) {
        localStorage.setItem("vv_token", token);
        await refresh();
        toast.success("Sesión iniciada con Google");
        navigate("/");
        return;
      }
      if (linked === "ok") {
        await refresh();
        toast.success("Gmail conectado correctamente");
        navigate("/");
        return;
      }
      navigate("/login");
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-gray-500">
      Procesando autenticación…
    </div>
  );
}
